import i18next from 'i18next'

/**
 * Function for formatting values depends on app language.
 * Example - number 7800,43 for DE lang will be displayed as 7,800.43, for EN lang 7.800,43
 * Values are always displayed with max 2 decimal digits
 * @param - value as number or string
 */
export const getLocalizedNumber = (value: number | string, isSmallScreen?: boolean): string => {
  const removeDecimals = Number.parseInt(String(value))

  return new Intl.NumberFormat(i18next.language, {
    maximumFractionDigits: isSmallScreen && removeDecimals.toString().length > 4 ? 0 : 2,
    minimumFractionDigits: 0,
  }).format(Number(value))
}
